import React from 'react';

type Props = {
  trackId: string;
};
const SoundCloud: React.FC<Props> = ({ trackId }) => {
  const src = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${trackId}&color=%23ff5500&visual=true&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=true`;
  return (
    <div>
      <iframe
        allow="autoplay"
        height="300"
        scrolling="no"
        src={src}
        width="100%"
      />
    </div>
  );
};

export default SoundCloud;
